import {
  EnumFunnelTrackingCookies,
  getCookieWithFallback,
  setCookieWithFallback,
} from '@core/tracking/funnelTracking'
import { getOauthAppIdOverride } from '@core/tracking/oauthAppId'

/**
 * Persists the OAuth app ID override into cookie/localStorage.
 * Unlike persistGuestId, no UUID fallback — does nothing when absent.
 */
export function persistOauthAppId() {
  const oauthAppId =
    getOauthAppIdOverride() ||
    getCookieWithFallback(EnumFunnelTrackingCookies.FW_OAUTH_APP_UID)?.value

  if (oauthAppId) {
    setCookieWithFallback(
      EnumFunnelTrackingCookies.FW_OAUTH_APP_UID,
      oauthAppId,
    )
  }
}
